import { useEffect, useRef, useState } from "react";
import Editor from "@arcgis/core/widgets/Editor.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import ServerInfo from "@arcgis/core/identity/ServerInfo";
import esriId from "@arcgis/core/identity/IdentityManager.js";


const EditorComponent = ({ mapView, visiblePanels }) => {
    const mapEditor = useRef(null);
    const [layers, setlayers] = useState()
    const [editor, setEditor] = useState()

    useEffect(() => {
        if (layers && visiblePanels.includes("editor")) {

            for (let i in layers) {
                const ly = layers[i]
                if (!mapView.map.allLayers.items.includes(ly)) {
                    try {
                        mapView.map.add(ly);
                    }
                    catch (e) { }
                }
            }          
        }

        else {
            if (layers) {
                //Desactivamos cualquier ewdición activa
                if (editor) {
                    //window.editorSGV = editor;
                    if (editor.activeWorkflow) {
                        editor.cancelWorkflow()                      
                        console.log("editor", editor)
                        console.log("activeWorkflow", editor.activeWorkflow)
                    }                  
                }
                for (let i in layers) {
                    const ly = layers[i]
                    if (mapView.map.allLayers.items.includes(ly)) {
                        mapView.map.remove(ly);
                    }
                }

            }

        }

    }, [visiblePanels])

    useEffect(() => {

        //const tokenServiceUrl = "https://idearagon.aragon.es/servicios/tokens/generateToken"
        const tokenServiceUrl = "https://idearagon.aragon.es/portallidar/sharing/rest/generateToken"

        let serverInfo = new ServerInfo({
            //server: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer", // URL de tu servidor de ArcGIS
            server: "https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer", // URL de tu servidor de ArcGIS
            tokenServiceUrl: tokenServiceUrl, // URL del servicio de generación de tokens
        });

        // Define la información del usuario (nombre de usuario y contraseña)
        let userInfo = {
            /*
            username: "VICA",
            password: "VICA$2024",
            */
            username: "IAAgua",
            password: "IAAgua!2025",
        };

        // Llama al método generateToken para obtener un token de autenticación
        esriId.generateToken(serverInfo, userInfo)
            .then(function (tokenInfo) {
                //INDICAMOS AL IDENTITYMANAGER QUE UTILICE EL TOKEN PARA LAS REQUEST QUE SE REALICEN A ESA URL
                let tokenServer = {
                    "server": serverInfo.server,
                    "token": tokenInfo.token
                };
                // Realiza una solicitud a un servicio seguro usando el token
                esriId.registerToken(tokenServer);

                const ly0 = new FeatureLayer({
                    //url: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/0",
                    url: "https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/0",
                    //definitionExpression: definitionExpression,
                    title: "Edición de EDARs gestionadas por el IAA en servicio",
                    sgvType: "EDICION"
                });
                const ly1 = new FeatureLayer({
                    //url: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/1",
                    url: "https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/1",
                    //definitionExpression: definitionExpression,
                    title: "Edición de EDARs en servicio en periodo de pruebas",
                    sgvType: "EDICION"
                });
                const ly2 = new FeatureLayer({
                    //url: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/2",
                    url: "https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/2",
                    //definitionExpression: definitionExpression,
                    title: "Edición de EDARs gestionadas por Ayuntamientos en servicio",
                    sgvType: "EDICION"
                });
                const ly3 = new FeatureLayer({
                    //url: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/3",
                    url: "https://idearagon.aragon.es/servicioslidar/rest/services/IAA/iaa_v4_sgv_FS/FeatureServer/3",
                    //definitionExpression: definitionExpression,
                    title: "Edición de EDARs en construcción",
                    sgvType: "EDICION"
                });

                //Cuando se apliquen cambios, refreescamos mapa tras unos segundos
                ly0.on("edits", function (event) {
                    setTimeout(() => {
                        mapView.goTo(mapView.extent);
                    }, "100");


                });
                ly1.on("edits", function (event) {
                    setTimeout(() => {
                        mapView.goTo(mapView.extent);
                    }, "100");


                });
                ly2.on("edits", function (event) {
                    setTimeout(() => {
                        mapView.goTo(mapView.extent);
                    }, "100");


                });
                ly3.on("edits", function (event) {
                    setTimeout(() => {
                        mapView.goTo(mapView.extent);
                    }, "100");


                });
                setlayers([ly0, ly1, ly2, ly3])

                mapView.map.add(ly0);
                mapView.map.add(ly1);
                mapView.map.add(ly2);
                mapView.map.add(ly3);

                let editor = new Editor({
                    container: mapEditor.current,
                    //container: "SgvEditorContainer_Editor",
                    view: mapView
                });
                setEditor(editor)
            })
            .catch(function (error) {
                // Error al generar el token
                console.error("Error al generar el token:", error);
            });



    }, [])

    return (
        <div ref={mapEditor}></div>
    )
}
export default EditorComponent;



